export default __webpack_public_path__ + "static/media/POPPINS-SEMIBOLDITALIC.62dee533.TTF";